export default __webpack_public_path__ + "static/Rwd-5f5a698e3f3255dea3bf826b4316df9e.jpg";